import { heroFeature } from "@/mocks/home";

export default function Hero() {
  return (
    <section id="top" className="border-b border-background-200/70">
      <div className="mx-auto max-w-[1280px] px-4 pt-8 pb-10 md:px-6 md:pt-12 md:pb-16">
        {/* masthead strip */}
        <div className="mb-8 flex flex-wrap items-center justify-between gap-3 border-b border-background-200/70 pb-4 md:mb-12">
          <div className="flex items-center gap-3 text-xs font-medium tracking-[0.25em] text-foreground-500 uppercase">
            <span className="text-primary-600">Issue 128</span>
            <span className="h-3 w-px bg-background-300"></span>
            <span>2026 年 10 月</span>
          </div>
          <div className="flex items-center gap-2 text-xs text-foreground-500">
            <span className="flex h-2 w-2 items-center justify-center rounded-full bg-primary-500"></span>
            编辑部实时更新中
          </div>
        </div>

        {/* magazine spread */}
        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] lg:gap-0">
          {/* left: text page */}
          <div className="flex flex-col lg:pr-12 xl:pr-16">
            <span className="mb-4 inline-flex w-fit items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-800">
              <i className="ri-quill-pen-line text-sm"></i>
              {heroFeature.kicker}
            </span>
            <h1 className="font-heading text-3xl leading-[1.25] font-black text-foreground-950 md:text-4xl lg:text-[40px] lg:leading-[1.2]">
              {heroFeature.title}
            </h1>
            <p className="mt-5 max-w-xl text-sm leading-7 text-foreground-600 md:text-base md:leading-8">
              {heroFeature.deck}
            </p>

            <div className="mt-7 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-foreground-500">
              <span className="font-medium text-foreground-800">{heroFeature.author}</span>
              <span className="h-3 w-px bg-background-300"></span>
              <span>{heroFeature.date}</span>
              <span className="h-3 w-px bg-background-300"></span>
              <span>{heroFeature.readTime}</span>
            </div>

            <div className="mt-8 flex flex-wrap items-center gap-3">
              <a
                href="#feed"
                className="group inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                阅读完整专访
                <i className="ri-arrow-right-line text-base transition-transform group-hover:translate-x-0.5"></i>
              </a>
              <a
                href="#ranking"
                className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-foreground-400"
              >
                <i className="ri-fire-line text-base text-primary-500"></i>
                查看热度榜
              </a>
            </div>
          </div>

          {/* right: cover page */}
          <div className="relative border-background-200/70 lg:border-l lg:pl-12 xl:pl-16">
            <figure className="group relative overflow-hidden rounded-lg bg-background-100">
              <div className="relative h-[420px] w-full md:h-[520px] lg:h-[560px]">
                <img
                  src={heroFeature.image}
                  alt={heroFeature.alt}
                  title="《琉璃之城》动画主视觉 · 新番情报"
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.03]"
                />
              </div>
              <figcaption className="absolute bottom-0 left-0 right-0 flex items-end justify-between gap-4 bg-gradient-to-t from-foreground-950/80 to-transparent p-5">
                <div>
                  <p className="text-[11px] tracking-[0.2em] text-primary-200 uppercase">
                    Cover Story
                  </p>
                  <p className="mt-1 font-heading text-lg font-bold text-background-50">
                    《琉璃之城》
                  </p>
                </div>
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-background-50/95 text-foreground-950">
                  <i className="ri-arrow-right-up-line text-lg"></i>
                </span>
              </figcaption>
            </figure>
            <p className="mt-3 text-right text-xs text-foreground-500">
              本期封面 · 插画 / 78 动漫编辑部
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}